import type React from 'react';

import { Button } from '@change/ds-core-ui';
import { TikTokIcon } from '@change/ds-icons';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

type Props = {
	onContinue: () => Promise<void>;
};

export const EducationModalBody: React.FC<Props> = ({ onContinue }) => {
	const { translate } = useI18n();

	return (
		<div className="mt-4 w-full" aria-label={translate('fe.components.psf.tiktok.modal_name')}>
			<Button
				variant="primary"
				leadingIcon={<TikTokIcon size="small" />}
				onClick={async () => onContinue()}
				data-testid="tiktok-share-continue"
				data-qa="tiktok-share-continue"
				className="w-full"
			>
				<Translate value="fe.components.psf.tiktok.continue" />
			</Button>
		</div>
	);
};
